"use strict";

(function () {
  "use strict";

  angular.module("login.setupTwoFactors", ["ui.router", "common"]);
})();